// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"401":"da370652","531":"49b318e5","809":"a72d18cf"}[chunkId] + ".chunk.js";
};